import { validateEmail, validateDoB } from "./input";
import { pushGtmEvent } from "./gtmEvent";
import { voyadoIdentifyCustomer } from "./voyado";
import cfg from "../config/config";

type SubscribeToNewsletter = (
  email: string,
  gender: string,
  honeypot: any,
  lang: string,
  dob: string,
) => Promise<{
  emailError: boolean;
  dobError: boolean;
  errorMessage: string | null | any;
  signupSuccess: boolean;
}>;
export const subscribeToNewsletter: SubscribeToNewsletter = async (
  email,
  gender,
  honeypot,
  lang,
  dob,
) => {
  if (validateEmail(email) && validateDoB(dob)) {
    try {
      const request = await fetch(
        `${
          cfg.BASE_PATH || ""
        }/api/newsletterSignup.json?email=${encodeURIComponent(
          email,
        )}&gender=${encodeURIComponent(gender)}&locale=${encodeURIComponent(
          lang,
        )}&dob=${encodeURIComponent(dob)}`,
        { method: "POST" },
      );

      const marketing = await request.json();

      pushGtmEvent("generate_lead", {
        ecommerce: {
          affiliation: "Online Store",
        },
      });

      voyadoIdentifyCustomer(email);
      if (marketing.errors && marketing.errors.length) {
        return {
          emailError: false,
          dobError: false,
          errorMessage: marketing.errors[0].name,
          signupSuccess: false,
        };
      } else
        return {
          emailError: false,
          dobError: false,
          errorMessage: null,
          signupSuccess: true,
        };
    } catch (error) {
      return {
        emailError: true,
        dobError: false,
        errorMessage: error,
        signupSuccess: false,
      };
    }
  } else {
    if (!validateEmail(email)) {
      return {
        emailError: true,
        dobError: false,
        errorMessage: "Please enter a valid email address",
        signupSuccess: false,
      };
    }

    if (!validateDoB(dob)) {
      return {
        emailError: false,
        dobError: true,
        errorMessage: "Please enter a valid date of birth",
        signupSuccess: false,
      };
    }

    return {
      emailError: false,
      dobError: false,
      errorMessage: "An error has occured",
      signupSuccess: false,
    };
  }
};
